export default __webpack_public_path__ + "static/media/ic-submit.30510d22.svg";